import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'mb-myaccount-tile',
  templateUrl: './mb-myaccount-tile.component.html',
  styleUrls: ['./mb-myaccount-tile.component.scss']
})
export class MbMyaccountTileComponent {

  @Input() backgroundImageLocation = ''
  @Input() backgroundImageLocationMobile = ''
  @Input() text = ''
  @Input() mobileText = ''
  @Input() linkText = ''
  @Input() linkUrl = ''
  @Input() heightREM = 17
  @Input() textAlignment = ''
  @Input() textLarge = false
  @Input() hover = true
  @Input() welcomeTile = false
  @Input() externalUrl = false

  constructor (
    private router: Router
  ) {
  }
  openLink () {
    if(this.externalUrl) {
      window.open(this.linkUrl, '_blank')?.focus()
    } else {
      this.router.navigate([this.linkUrl])
    }
  }
}
